import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import useMe from '@/renderer/utils/useMe';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import MailingListForm from './MailingListForm';

export function MailingListFormPage({
  guarded = false,
  subtitle,
  hideLogo = false,
  showMarketing = true,
}: {
  guarded: boolean;
  subtitle?: (React.ReactNode | JSX.Element)[] | React.ReactNode | JSX.Element | string;
  hideLogo?: boolean;
  showMarketing?: boolean;
}) {
  const [me] = useMe(true);
  return (
    <>
      <div className="flex min-h-full items-center justify-center bg-[Canvas] px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-5">
          {!hideLogo && (
            <div>
              <a href="/">
                <Logo className="mx-auto size-16 select-none" />
              </a>
            </div>
          )}
          {me ? (
            <div className="text-center font-medium text-base">
              <CheckCircleIcon className="mx-auto mb-2 size-12 text-emerald-500" />
              You&apos;re already signed for our mailing list!
            </div>
          ) : (
            <>
              {!!subtitle && <h3 className="text-center font-normal text-xl">{subtitle}</h3>}
              {showMarketing && (
                <div className="space-y-5 text-sm">
                  <div className="font-semibold text-base">
                    Free Picks. Early Info. No Nonsense.
                  </div>
                  <div>
                    Join the RAS mailing list for free updates throughout the season. You’ll get:
                  </div>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>Early notice on upcoming releases</li>
                    <li>Occasional free picks and insights</li>
                    <li>Service updates and helpful reminders</li>
                  </ul>
                  <p>We don’t send often — just when it’s worth your time.</p>
                  <p>No spam. Just real info from RAS.</p>
                  <div>Drop your email below to get started.</div>
                </div>
              )}
              <MailingListForm guarded={guarded} />
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
